var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-auto inline-block h-16 sm:h-12 bg-label text-xl sm:text-sm font-extrabold leading-normal pl-5 pr-6 pt-3 pb-3 text-center"},[_vm._v("\n    "+_vm._s(_vm.text.toUpperCase())+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }